<template>
  <div style="display: flex; justify-content: space-between;align-items: center">
    <cargo-advance-select
      :select-type="TYPE_NAMES.basic_data_Seaport"
      :default-value="job.loadingPortCode"
      style="flex:1"
      v-bind="$attrs"
      v-on="$listeners"
      @parentCallBack="onParentCallBack"
    />&nbsp;
    <el-checkbox v-model="job.transfering" style="padding-left:2px;" @change="onChange('transfering')">{{ $t('SeaExport.Transit') }}</el-checkbox>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'SeLoadingPortCode',
  components: { cargoAdvanceSelect },
  props: {
    job: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      TYPE_NAMES
    }
  },
  methods: {
    onParentCallBack(data) {
      this.job.loadingPortCode = data.value
      this.$emit('childrenChange', [{ key: 'loadingPortCode', value: this.job.loadingPortCode }])
    },
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
